import React, { useState, useEffect} from "react";
import "./EmploymentVerification.css";
import Edit from "../../assets/img/penEditDarkGrey.png";
import { acceptUanEmployment ,uploadSalarySlip, removeFile, updateUanEmployment, ModifyUanEmployment, modifyUanEmployment, fetchUandetails} from "../../Actions/uanActions";
import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import Bin from "../../assets/img/delete_Icon.png";
import RightArrowIcon from "../../assets/img/arrow-right-icon.png";
import UploadIcon from "../../assets/img/upload-icon-blue.svg";
import InputField from "../InputField";
import ImagePopup from "../ImagePopup";
import CustomPopUp from "../Common/customPopUp";
import MultipleUploadSection from "../MultipleUploadSection/MultipleUploadSection";
import UploadPreviewUAN from "./UploadPreviewUAN";
import { toast } from "react-toastify";

const EmploymentHistory = (props) => {
  const [selectedId, setSelectedId] = useState('');
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [documentID, setDocumentID] = useState("");
  const [doj, setDoj]=useState();
  const [doe, setDoe]=useState();
  const [documentPreview, setDocumentPreview] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [image, setImage] = useState("");
  const [allDocumentPreview, setAllDocumentPreview] = useState([]);
  const [allDocumentID, setAllDocumentID] = useState([]);
  const [isTillDate, setIsTillDate] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [name, setName] = useState('');
  const [fatherName, setFatherName] = useState('');
  const [errors,setErrors] = useState({});
  const [isUan,setIsUan] = useState(''); 
  const [previewArr,setPreviewArr] = useState([]); 
  const [isUpdateDisabled,setIsUpdateDisabled] = useState(false);
  const [isAcceptDisabled, setIsAcceptDisabled] = useState(false);

  // useEffect( () => {
  //   debugger
  //   if(Object.keys(props?.history).length > 0){
  //     setDoe(props.history)
  //   }
  // },[props?.history])

 const handleAccept=(id,uploaded_documents,fatherName)=>{
  setIsAcceptDisabled(true);
  let arr=[]
  console.log(uploaded_documents)
  uploaded_documents?.map((i)=>{
    
    arr.push(i.id)
  })
  console.log(arr)

  dispatch(acceptUanEmployment(id,arr,fatherName,refreshCallback));
  setTimeout(() => {
    setIsAcceptDisabled(false);
  }, 1000);
}

const refreshCallback = () => {
   props.callBackFunction();
 }

 const saveDOJInput=(arg)=>{
  if (arg == "Invalid date") {
    setDoj('')    
    setErrors((prev) => ({
      ...prev,
      doj: 'This field is required.'
    }))
  }else{
    setDoj(arg);
    setErrors((prev) => ({
      ...prev,
      doj: ''
    }))
  }
}
const saveDOEInput=(arg)=>{
  if(arg == "Invalid Date"){
    setDoe('');
    setErrors((prev) => ({
      ...prev,
      doe: 'This field is required.'
    }))
  }else{
    setDoe(arg);
    setErrors((prev) => ({
      ...prev,
      doe: ''
    }))
  }
}

 const handleEditDates=(id)=>{
  setSelectedId(id);
  let previewArr = [];
  let docIdArr = [];
  let allDocIds = []
  props?.history.map((data) => {
    allDocIds.push()
    if(data.id == id){
      setDoe(data.date_of_exit);
      setDoj(data.date_of_joining);
      setIsTillDate(data.emp_is_till_date?true:false)
      setDocumentPreview(data?.uploaded_documents?.[0]?.preview_key);
      setFileName(data?.uploaded_documents?.[0]?.file_name)
      setCompanyName(data?.company_name);
      setName(data?.candidate_name);
      setFatherName(data?.father_name);
      setIsUan(data?.uan_number);
      setPreviewArr(data?.uploaded_documents);
      data?.uploaded_documents.map((file) => {
        previewArr.push(file?.preview_key);
        docIdArr.push(file?.id);
      })
    }
  })

  setAllDocumentPreview(previewArr);
  setAllDocumentID(docIdArr);
  if(previewArr.length == 0){
   setFileName('');
   setDocumentPreview(''); 
  }
  setErrors({});
}

console.log(fileName);
 console.log(allDocumentPreview);

 const handleCancelUpdate=()=>{
  setSelectedId('');
  setDoe('');
  setDoj('');
  setIsTillDate(false);
  setDocumentPreview('');
  setFileName('');
  setAllDocumentPreview([]);
  setAllDocumentID([]);
  setCompanyName('');
  setName('');
  setFatherName('');
  setIsUan('');
 }

 const handleUpdate=()=>{
  if(doj != ""  &&  (isUan ||  allDocumentPreview.length>0) && (isTillDate||doe!='') && 
  (name != '' && name) && (companyName != '' && companyName) && (fatherName != '' && fatherName )){
    const formData = props?.formData
  setIsUpdateDisabled(true);
  let record = {};
  record.uan_history_id = selectedId;
  record.candidate_id = formData?.candidate_id;
  record.initial_case_id = formData?.candidates?.initial_case_id;
  record.case_check_id = formData?.checksDetails[0]?.case_check_id;
  // record.company_name = ;
  record.date_of_joining = doj;
  record.date_of_exit = doe;
  record.father_name = fatherName;
  record.company_name = companyName;
  record.candidate_name = name;
  // record.father_name = ;
  record.document_id = allDocumentID;
  // record.remarks = ;
  record.is_till_date = isTillDate?1:0 ;
  
  dispatch(modifyUanEmployment(record,callback));
  }
  else{
    // toast.error("Please Fill all the Fields.", {
    //   position: "top-right",
    //   autoClose: 3000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
    // return false;

    if(doe == '' && !isTillDate){
      setErrors((prev) => ({
        ...prev,
        doe: 'This field is required.'
      }))
    } 
    if(doj == ''){
      setErrors((prev) => ({
        ...prev,
        doj: 'This field is required.'
      }))
    }
    if(companyName == ''){
      setErrors((prev) => ({
        ...prev,
        companyName: 'This field is required.'
      }))
    }
    if(name == ''){
      setErrors((prev) => ({
        ...prev,
        name: 'This field is required.'
      }))
    }
    if(fatherName == '' || fatherName == null){
      setErrors((prev) => ({
        ...prev,
        fatherName: 'This field is required.'
      }))
    }
    if(!isUan && allDocumentPreview.length <= 0 ){
      setErrors((prev) => ({
        ...prev,
        upload: 'This field is required.'
      }))
    }
  }
 }

 const callback = (data,res) => {
  if(res?.code == 400){
    setIsUpdateDisabled(false);
  }else{
    dispatch(fetchUandetails(data?.candidate_id, data?.initial_case_id, data?.case_check_id));
    setSelectedId('');
    setIsUpdateDisabled(false);
  }
}
 const dispatch = useDispatch();

 const handleChange = (file) => {
  // debugger
  let size=0;
  let extension_error=0;
  for(let i=0;i<file.length;i++){
    let arr = file[i]?.type.split('/')
    if(arr[arr.length-1] !== "png" && arr[arr.length-1] !== "jpg" && arr[arr.length-1] !== "pdf" && arr[arr.length-1] !== "jpeg"){
      extension_error+=1
    }
    size+=file[i]?.size
  }

  if(extension_error!=0){
    alert("Wrong file format");
    return false;
  }
 
    if (size> 5242880) {
      alert("File cannot be larger than 5mb");
      return false;
    }
  setFileName(file[0].name);
  setFileError(false);
  console.log(props?.formData)
  let record = {};
  record.mode = "uan_employment_proof";
  record.chkid = props?.formData?.checksDetails[0]?.case_check_id;
  record.uan_history_id = selectedId;
  // record.docid =props?.formData?.checksDetails[0]?.required_documents?.[0]?.id;
  record.docid = '1566';
  const files = Object.keys(file).map(key => {
    const innerObject = file[key];
    return innerObject;
  });
  record.uan_employment_proof = files;
  console.log(file)
  console.log(files);
  setErrors((prev) => ({
    ...prev,
    upload: ''
  }))
  
  // enable in case of update and dispatch api with doc_id and 
  // after api response save all url in allDocumentsPreview 

  dispatch(uploadSalarySlip(record, file, callbackUploadFiles));

  // let formData = {};
  // formData.group = 21;
  // const currentUrl = window.location.href;
  // const [partA, partB] = currentUrl.split("/check-detail/");
  // const [reference, route] = partB.split("/");
  // formData.referenceNo = reference;
  // dispatch(getVisualDoc(formData));
};

const callbackUploadFiles = (data) => {
  // console.log(selectedId)
  let allData = Object.values(data);
  let prevArr = []
  let docIdArr = []
  allData.map((item) => {
    prevArr.push(item.preview_key);
    docIdArr.push(item.document_id);
  })
  setPreviewArr(allData);
  console.log(prevArr);
  setAllDocumentPreview(prevArr);
  setAllDocumentID(docIdArr);
  deleteCallback(1);
}

const storeData = useSelector((state) => state.uploadSalary);
  const { uploadSalaryData, loading } = storeData;
  useEffect(() => {
    if (typeof loading !== "undefined" && loading !== null) {
      if (loading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }
    }
    // if(typeof uploadSalaryData !== "undefined" && uploadSalaryData !== null && isLoading==true){
    //   setDocumentID(uploadSalaryData?.data?.[0]?.document_id);
    //   setDocumentPreview(uploadSalaryData?.data?.[0]?.preview_key);
    //   let arr = []
    //   for( let idx in uploadSalaryData?.data){
    //     arr.push(idx?.preview_key);
    //   }
    //   // setAllDocumentPreview(uploadSalaryData?.data?.[0]?.preview_key);
    // }
  }, [uploadSalaryData]);
const handleTrashClick = () => {
  // debugger;
  setFileName("");
  let record = {};
  // debugger
  record.mode = "uan_employment_proof";
  record.chkid = props?.formData?.checksDetails?.[0]?.case_check_id;
  record.uan_history_id = selectedId;
  record.doc_ref = "all";
  record.document_ids = allDocumentID;
  record.docid =props?.formData?.checksDetails?.[0]?.required_documents?.[0]?.id;
  dispatch(removeFile(record,deleteCallback));
  setAllDocumentPreview([]);
};

const deleteCallback = (val) => {
  // debugger
  const formData = props?.formData;
  // if(val){
    dispatch(fetchUandetails(formData?.candidate_id, formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id));
  // }else{
  //   dispatch(fetchUandetails(formData?.candidate_id, formData?.candidates?.initial_case_id, formData?.checksDetails[0]?.case_check_id));
  // }
}

// const uploadCallback = (data) => {
//   debugger
//   console.log(selectedId);
//   // data.map((emp) => {
//   //   if(emp.id == selectedId){
//   //     hand
//   //   }
//   // })
//   handleEditDates(selectedId);
// }


const handleImageModal = (e, modalImage) => {
  e.preventDefault();
  e.stopPropagation();
  setImage(modalImage);
  setShowImageModal(true);
  // setShowImageModal(true);
};

const closePopup = () => {
  setImage("");
  setShowImageModal(false);
};

const handleTillDate=()=>{
  setIsTillDate(!isTillDate)
  setDoe('');
  setErrors((prev) => ({
    ...prev,
    doe: ''
  }))
}

const renderDragDropChildren = () => (
  <>
    <input type="file" id="myFile" class="mt-2" name="filename" />

    {/* <div class="w-100 bg-gray p-5 mb-3 text-center file-upload">
      <ul class="mt-4">
        <li>
          <i data-feather="upload-cloud">
          
          </i>
        </li>
        <li class="mt-4">
         
          <p class="fnt-14 text-primary" style={{ cursor: "pointer" }}>
            Click to upload <span class="text-gray">or drag and drop</span>
          </p>
        </li>
        <li class="fnt-12 text-gray">XLS or CSV File (max. 5mb)</li>
      </ul>
    </div> */}

    <div className="row uploadBox justify-content-around border rounded w-100 bg-light rounded ml-1">
      <div className="col-2 align-self-center p-0">
        <img src={UploadIcon} alt="UploadIcon" width="32px" height="32px" />
      </div>
      <div className="col-8 align-self-center">
        <div className="row uploadCardText1">Upload salary slip or Relieving letter</div>
        <div className="row uploadCardText2">
          upload PNG, JPG, PDF etc (max file size 5mb)
        </div>
      </div>
      
    </div>
  </>
);

console.log(allDocumentPreview)

const handleInputChange = (e) => {
  let val = e.target.value;
  if(e.target.id == 'company_name'){
    setCompanyName(val);
    setErrors((prev) => ({
      ...prev,
      companyName: ''
    }))
  }else if(e.target.id == 'candidate_name'){
    setName(val);
    setErrors((prev) => ({
      ...prev,
      name: ''
    }))
  }else if(e.target.id == 'father_name'){
    setFatherName(val);
    setErrors((prev) => ({
      ...prev,
      fatherName: ''
    }))
  }
  
}

const handleSingleDocDelete = (updatedArr) => {
  console.log(updatedArr);
  if(updatedArr.length == 0){
    setShowImageModal(false);
    setFileName('');
    setDocumentPreview(''); 
  }else{
    setPreviewArr(updatedArr);
    let previewArr = [];
    let docIdArr = [];
    updatedArr.map((file) => {
      previewArr.push(file?.preview_key);
      docIdArr.push(file?.id);
    })
    setAllDocumentPreview(previewArr);
    setAllDocumentID(docIdArr);
  }
  reRender();

}

const reRender = () => {
  if(props?.hasOwnProperty('reRenderAgain')){
    props.reRenderAgain();
  }
};
  return (
    <>
    {showImageModal && (
        <UploadPreviewUAN
          showModalBox={1}
          title={"Uploaded file"}
          description={"..."}
          isAdd={true}
          // image={image}
          // image={allDocumentPreview}
          closePopup={closePopup}
          sliderData={allDocumentPreview}
          // sliderData={previewArr}
          setAllDocumentPreview={setAllDocumentPreview}
          // title={title}
          formData={props?.formData}
          selectedId={selectedId}
          allDocumentID={allDocumentID}
          // allDocumentPreview={allDocumentPreview}
          handleSingleDocDelete={handleSingleDocDelete}
          previewArr={previewArr}
        />
      )}
{props?.history?.map((data) =>
        data?.id != selectedId ? (
          <div className="employment-history px-1 py-3 my-3">
            <div className="col col1 d-flex flex-column">
              <div className="row p-0 m-0 w-100 my-1">
                <div className="employment-history-title col-lg-6 col-md-12 col-sm-12 p-0 m-0">
                  {/* {employmentDetailsColOne.title} */}
                  Company:
                </div>
                <div
                  // className={`employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0 ${employmentDetailsColOne[0].textClass}`}
                  className="employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0"
                >
                  {/* {employmentDetailsColOne.text} */}
                  {data?.company_name}
                </div>
              </div>
              <div className="row p-0 m-0 w-100 my-1">
                <div className="employment-history-title col-lg-6 col-md-12 col-sm-12 p-0 m-0">
                  {/* {employmentDetailsColOne.title} */}
                  Name:
                </div>
                <div
                  // className={`employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0 ${employmentDetailsColOne[0].textClass}`}
                  className="employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0"
                >
                  {/* {employmentDetailsColOne.text} */}
                  {data?.candidate_name}
                </div>
              </div>
              <div className="row p-0 m-0 w-100 my-1">
                <div className="employment-history-title col-lg-6 col-md-12 col-sm-12 p-0 m-0">
                  {/* {employmentDetailsColOne.title} */}
                  Father's Name:
                </div>
                <div
                  // className={`employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0 ${employmentDetailsColOne[0].textClass}`}
                  className="employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0"
                >
                  {/* {employmentDetailsColOne.text} */}
                  {data?.father_name}
                </div>
              </div>
            </div>
            <div className="col col2 d-flex flex-column">
              <div className="row p-0 m-0 w-100 my-1">
                <div className="employment-history-title col-lg-6 col-md-12 col-sm-12 p-0 m-0">
                  {/* {employmentDetailsColTwo.title} */}
                  Date of Joining:
                </div>
                <div className="employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0">
                  {/* {employmentDetailsColTwo.text} */}
                  {data?.date_of_joining?.slice(0, 10)}
                </div>
              </div>
              <div className="row p-0 m-0 w-100 my-1">
                <div className="employment-history-title col-lg-6 col-md-12 col-sm-12 p-0 m-0">
                  {/* {employmentDetailsColTwo.title} */}
                  Date of Exit:
                </div>
                <div className="employment-history-text ml-1 col-lg-6 col-md-12 col-sm-12 p-0">
                  {/* {employmentDetailsColTwo.text} */}
                  {data?.date_of_exit?.slice(0, 10)}
                </div>
              </div>
            </div>
            <div className="col col3 pt-3">
              {data?.status == 0 ? (
                <button
                  className="btn employment-history-btn"
                  disabled={isAcceptDisabled}
                  onClick={() => {
                    handleAccept(data?.id, data?.uploaded_documents,data?.father_name);
                  }}
                > {data?.uan_number ? 'Accept' : 'Add'}
                  {/* Accept */}
                </button>
              ) : (
                <div
                  className="btn employment-history-btn"
                  style={{ backgroundColor: "#B8DC6F" }}
                >{data?.uan_number ? 'Accepted' : 'Added'}
                  {/* Accepted */}
                </div>
              )}
              {
              data?.status == 0 ? 
              (
                <div
                  className="btn employment-history-btn"
                  onClick={() => {
                    handleEditDates(data?.id);
                  }}
                >
                  <span>
                    <img
                      src={Edit}
                      alt="Edit"
                      style={{ paddingBottom: "2px" }}
                    />
                  </span>
                  Edit Dates
                </div>
              ) 
              : (
                <></>
              )
              }
            </div>
          </div>
        ) : (
          <div className="addNewEmploymentDetail px-1 py-3 my-3">
            {/* <div className="">
          <form>
            <div className="form-group col-6">
              <label for="inputCity" className="addEmpCompanyName">
                Company Name
              </label>
              <input
                type="text"
                className="form-control addEmpCompanyInput"
                id="inputCity"
                placeholder="Enter Company Name"
              />
            </div>
          </form>
        </div> */}

<div className="p-2 row">
            <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 row">
              <div className="col-lg-4 col-md-12 col-sm-12">
                <form>
                <div className="form-group">
              <label for="inputCity" className="addEmpCompanyName">
                Company Name <sup className="text-danger">{''}*</sup>
              </label>
              <input
                type="text"
                className="form-control addEmpCompanyInput"
                id="company_name"
                placeholder="Enter Company Name"
                onChange={(e) => {handleInputChange(e)}}
                value={companyName}
              />
              <p className="text-danger">{errors.companyName}</p>
                </div>
                </form>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12">
                <form>
                <div className="form-group">
              <label for="inputCity" className="addEmpCompanyName">
                Name <sup className="text-danger">{''}*</sup>
              </label>
              <input
                type="text"
                className="form-control addEmpCompanyInput"
                id="candidate_name"
                placeholder="Enter Name"
                onChange={(e) => {handleInputChange(e)}}
                value={name}
              />
              <p className="text-danger">{errors.name}</p>
                </div>
                </form>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12">
                <form>
                <div className="form-group">
              <label for="inputCity" className="addEmpCompanyName">
                Father's Name <sup className="text-danger">{''}*</sup>
              </label>
              <input
                type="text"
                className="form-control addEmpCompanyInput"
                id="father_name"
                placeholder="Enter Father's Name"
                onChange={(e) => {handleInputChange(e)}}
                value={fatherName}
              />
              <p className="text-danger">{errors.fatherName}</p>
                </div>
                </form>
              </div>
            </div>
            </div>

            <div className="p-2 row">
            <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 row">
          
          <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 w-100">

                <form>
                  <div className="form-group col">
                    <label for="inputDOJ" className="addEmplabelInput">
                      Date of Joining  <sup className="text-danger">{''}*</sup>
                    </label>
                    <InputField
                      inputType="7"
                      inputName="date_of_joining"
                      inputValue={doj}
                      saveDate={(index, argDate) => {
                        saveDOJInput(argDate);
                      }}
                      placeholder="Date of Joining:"
                      maximumDate={doe}
                    />
                  <p className="text-danger">{errors.doj}</p>
                  </div>
                </form>
              </div>

              <div className="col-lg-6 col-md-12 col-sm-12 p-0 m-0 w-100">
                <form>
                  <div className="form-group col">
                    <label for="inputDOE" className="addEmplabelInput">
                      Date of Exit  <sup className="text-danger">{''}*</sup>
                    </label>
                    {!isTillDate&&<InputField
                      inputType="7"
                      inputName="date_of_exit"
                      inputValue={doe}
                      saveDate={(index, argDate) => {
                        saveDOEInput(argDate);
                      }}
                      placeholder="Date of Exit"
                      minimumDate={doj}
                    />}
                  <p className="text-danger">{errors.doe}</p>
                    {/* Till Date-START */}
                <div className="form-group form-check mt-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="exampleCheck1"
                    checked={isTillDate}
                    onClick={handleTillDate}
                  />
                  <label className="form-check-label" for="exampleCheck1">
                    Till Date
                  </label>
                </div>
                {/* Till Date-END */}
      
              </div>
            </form>
            </div>
          </div>  

              {!data?.uan_number ? 
              <div className="col-lg-4 col-md-12 col-sm-12 pl-1 pr-3">
                <label className="addEmplabelInput pl-2">Proof of Employment  <sup className="text-danger">{''}*</sup></label>
                {/* {fileName == "" ? ( */}
                  <>
                    <FileUploader
                      hoverTitle={"Choose Files"}
                      classes={"file-upload w-100 border-0 mt-n2"}
                      handleChange={handleChange}
                      multiple={true}
                      name="file"
                      children={renderDragDropChildren()}
                      onSizeError={(file) => {
                        alert("file size larger than 5 mb");
                      }}
                      onClick={(e) => (e.target.value = null)}
                    />
                    <p className="text-danger">{errors.upload}</p>
                    {/* {fileError ? (
                      <p className="text-danger">This is a required field.</p>
                    ) : (
                      ""
                    )} */}
                  {/* </> */}
                {/* ) : ( */}
                  {/* <> */}

                   { fileName != '' && <div
                      style={{
                        maxHeight: "69px",
                        cursor: "pointer",
                        borderRadius: "4px",
                        border: "1px solid var(--gray-300, #D0D5DD)",
                        background: "var(--White, #FFF)",
                      }}
                      className="col-12 d-flex align-items-center justify-content-center bg-white uploadedDoc my-2 w-100 ml-1"
                    >
                      {/* <img
                        src={documentPreview}
                        alt="UploadedDoc"
                        style={{
                          maxWidth: "65px",
                          width: "100%",
                        }}
                      /> */}
                      <div className="d-flex align-items-center justify-content-between w-100 mx-3">
                        <p
                          className="text-truncate pt-3"
                          style={{
                            maxWidth: 200,
                          }}
                        >
                          {/* {fileName} */}
                          {allDocumentPreview.length} files uploaded
                        </p>
                        <i
                          class="fa-regular fa-eye mr-3 cursor-pointer"
                          onClick={(e) =>
                            handleImageModal(e, allDocumentPreview)
                          }
                        ></i>
                        <img
                          src={Bin}
                          onClick={() => handleTrashClick()}
                          alt="Delete"
                          style={{ maxWidth: "15px", width: "100%" }}
                        />
                      </div>
                    </div>}
                  </>
                {/* )} */}
              </div> : 
              <div className="col-5"></div>}
              <div className="col col3 addEmp-buttonsBox p-2 pt-4">
                <div
                  className="btn addEmp-cancelbtn"
                  onClick={handleCancelUpdate}
                >
                  Cancel
                </div>
                <button className="btn addEmp-addbtn" onClick={handleUpdate} disabled={isUpdateDisabled}>
                  Update
                </button>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default EmploymentHistory;

